// import moment from 'moment';

import dateComparator from "./DateComparator";

import filterParams from "./DateFilter";

export const columnDefs = [
  {
    headerName: "ID",
    field: "idpatient",

    hide: true,
  },
  {
    headerName: "fk_id_medecin",
    field: "fk_id_medecin",

    hide: true,
  },
  {
    headerName: "DATE_NAISSANCE_SERVER",
    field: "DATE_NAISSANCE_SERVER",

    hide: true,
  },
  {
    headerName: "AGEPATIENT",
    field: "AGEPATIENT",

    hide: true,
  },
  // {
  // 	headerName: 'Statut',
  // 	field: 'civilite',
  // 	checkboxSelection: true,
  // },
  {
    headerName: "Nom",
    field: "nom",
    checkboxSelection: true,
    tooltipField: "nom",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
  },
  {
    headerName: "Prenom",
    field: "prenom",
    tooltipField: "prenom",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
  },

  {
    headerName: "Date de naissance",
    field: "date_naissance",

    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    tooltipField: "date_naissance",
    tooltipComponentParams: { color: "#ececec" },
    comparator: dateComparator,
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
  },
  {
    headerName: "Tel",
    field: "tel",
    tooltipField: "tel",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
  },
  {
    headerName: "Pathologie principale",
    field: "pathologie_principale",
    tooltipField: "pathologie_principale",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
  },
  {
    headerName: "allergie_connue",
    field: "allergie_connue",
    tooltipField: "allergie_connue",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  // { headerName: 'Tel2', field: 'tel2' },
  // { headerName: 'Tel3', field: 'tel3' },
  {
    headerName: "Date de creation",
    field: "date_creation",
    // valueFormatter: dateHeureFormater,
    tooltipField: "date_creation",
    tooltipComponentParams: { color: "#ececec" },

    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  {
    headerName: "Date de modification",
    field: "date_de_modification",
    // valueFormatter: dateHeureFormater,
    tooltipField: "date_de_modification",
    tooltipComponentParams: { color: "#ececec" },

    filter: "agDateColumnFilter",
    filterParams: filterParams,
    sortable: true,
    comparator: dateComparator,
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  {
    headerName: "Commentaire",
    field: "commentaire_sur_patient",
    tooltipField: "commentaire_sur_patient",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  {
    headerName: "Medecin",
    field: "user_name",
    tooltipField: "user_name",
    tooltipComponentParams: { color: "#ececec" },
    filterParams: {
      defaultOption: "startsWith",
    },
    cellClass: (params) => {
      let ID = sessionStorage.getItem("ID_Session");
      // eslint-disable-next-line
      if (params?.data?.idpatient == ID) {
        return "aggridGoBackStyles";
      } else {
        return "null";
      }
    },
    hide: true,
  },
  // { headerName: 'CIN', field: 'cin' },
  // { headerName: 'Mutuelle', field: 'nom_mutuelle' },
];

export const defaultColDef = {
  sortable: true,
  // editable: true,
  flex: 1,
  // filter stuff
  filter: true,
  // floatingFilter: true,
  suppressMovable: true,
  suppressMenu: true,
  // end of filter stuff
  minWidth: 100,
  resizable: true,
  //   tooltipComponent: "customTooltip",
  filterParams: {
    newRowsAction: "keep",
    // buttons: ['apply', 'clear'],
  },
};
